import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';


@Pipe({
    name: 'titleNombreApellidos',
    standalone: true
})
export class TitleNombreApellidos implements PipeTransform {

  transform(cadena: string): string {

    //console.log("Pipe TitleNombreApellidos", cadena);
    
    if(cadena){
      if(cadena.includes(',')){
        let cadenaGestion = cadena.split(',')
        if (cadenaGestion.length > 1){
          cadena = cadenaGestion[1]?.trim() + ' ' + cadenaGestion[0]?.trim()
         // console.log("cadenaGestionlength ", cadenaGestion.length, ' cadena ' , cadena);
        }else if(cadenaGestion.length == 1){
          cadena = cadenaGestion[0]?.trim()
        }
        return cadena
      }
    }
  }
}



